<template>
  <div>
    <Notifications />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
import PublicLayout from "@/layouts/PublicLayout.vue";

const defaultLayout = "public-layout";
import BackofficeLayout from "./layouts/BackofficeLayout.vue";
import { Notifications } from "@estaly/ui";

export default {
  components: {
    BackofficeLayout,
    PublicLayout,
    Notifications,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || defaultLayout;
    },
    unseenClaimsCount() {
      return this.$store.state.claims.inboxCounts.unseen;
    },
  },
  watch: {
    unseenClaimsCount: {
      immediate: true,
      handler(count) {
        document.title = count > 0 ? `(${count}) Estaly` : "Estaly";
      },
    },
  },
};
</script>
